export const dataLayerPush = (data) => {
  if (typeof window !== "undefined" && window.dataLayer !== "undefined") {
    window.dataLayer.push(data);
  }
};
